import classNames from 'classnames'

import * as styles from './TextareaSkeleton.module.css'

function TextareaSkeleton({
  className,
  textareaClassName,
  withLabel,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={classNames(styles.textareaSkeleton, className)}
    >
      {withLabel ? <div className={styles.label} /> : null}
      <div className={classNames(styles.textarea, textareaClassName)} />
      <div className={styles.helpText} />
    </div>
  )
}

export default TextareaSkeleton
